/**
 * Copyright (c) 2000-present Liferay, Inc. All rights reserved.
 *
 * This library is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Lesser General Public License as published by the Free
 * Software Foundation; either version 2.1 of the License, or (at your option)
 * any later version.
 *
 * This library is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more
 * details.
 */


import sidebar from "./sidebar";
import intSlider from "./slider";
//import newTicketModal from "./newTicketModal";
import datatables from "./datatables";
import register from "./register";
import loader from "./loader";
import tour from "./tour";
import sc from "./smooth-scrollbar";

/*
 * This function gets loaded when all the HTML, not including the portlets, is
 * loaded.
 */
AUI().ready(function () {

    sidebar();
    intSlider();
    //newTicketModal();
    if ($('.user-manag-container').length) {
        //datatables();
    }
    if ($('.register-container').length) {
        register();
    }
    tour();
    initBasketCount();
    initDatePicker();
    window.smoothScrollbar.initAll();
});

Liferay.on('init-date-picker',function(event) {
    initDatePicker();
})

Liferay.on('init-swiper',function(event) {
    intSlider();
})

Liferay.on('init-loader', function () {
    loader();
})


Liferay.on('init-datatable', function () {
    datatables();
})
/*
Liferay.on('selectMachine', function (event) {
    console.log('select-machine', event)
    $('.card--machines').removeClass('card--machines--selected')
    $(`[data-machine-serial="${event.machineSerial}"]`).addClass('card--machines--selected')
});
*/
/*
 * This function gets loaded after each and every portlet on the page.
 *
 * portletId: the current portlet's id
 * node: the Alloy Node object of the current portlet
 */
Liferay.Portlet.ready(function (_portletId, _node) {});

/*
 * This function gets loaded when everything, including the portlets, is on
 * the page.
 */
Liferay.on("allPortletsReady", function () {});

function initDatePicker(){
    $(".date-picker").datepicker({
        altFormat: "yy-mm-dd"
    }).on( "keyup", function() {
        var date;
        try {
            date = $.datepicker.parseDate( $.datepicker._defaults.dateFormat, this.value );
        } catch ( e ) { }

        if ( !date ) {
            console.log("Reset date value");
            $("#" + $( this ).data("target")).val( "" );
        }
    });

    $(".date-picker").each(function( index ) {
        console.log("Start init date picker");
        var initialValue = $( this ).val();
        console.log($( this ).data("target"));
        $( this ).datepicker( "option", "dateFormat", $( this ).data("date-format"));
        $( this ).datepicker( "option", "defaultDate", initialValue);
        $( this ).datepicker( "option", "altField", "#" +$( this ).data("target"));
        console.log("end init");
    });
}


function initBasketCount(){
    if(themeDisplay.isSignedIn()){
        $.ajax({
             url: "/o/e-com-rest/v2.0/commons/get-cart-item-counts",
             data: {
             "doAsUserId":  themeDisplay.getDoAsUserIdEncoded()
             },
             headers: {"x-csrf-token": Liferay.authToken},
             type: "GET",
             beforeSend: function(xhr){
                //xhr.setRequestHeader('X-Test-Header', 'test-value');
             },
             success: function(cart) {
                 var items_count = 0;
                 console.log(cart);
                 console.log(cart.actions);
                // parte di hide and shows delle proprietà
                 $("li[class='services']").hide();
                 $("li[class='products']").hide();
                 $("li[class='equipments']").hide();
                 for (const flag in cart.actions.featuresFlag) {
                     $("li[class='"+flag+"']").show();
                 }

                 var subtitle = Liferay.Language.get("blm.portal.ecommerce.cart.dropdown-item.subtitle");
                 subtitle = subtitle.replaceAll("{{count}}", "0");
                 $(".basket-section .subtitle").text(subtitle);
                 $(".basket-section .itemNumber").text("0");

                 if (cart.items){
                    cart.items.forEach((c) => {
                        subtitle = Liferay.Language.get("blm.portal.ecommerce.cart.dropdown-item.subtitle");
                        subtitle = subtitle.replaceAll("{{count}}", c.count);
                        $(".basket-section ." + c.id + " .subtitle").text(subtitle);
                        $(".basket-section ." + c.id + " .itemNumber").text(c.count);
                        items_count += c.count;
                        if (c.count>0){
                            $("li[class='"+c.id+"']").show();
                        }
					} )

				}


				$(".basketCount").text(items_count);
             }
          });
      }
}

document.initBasketCount = initBasketCount;


document.filterFunction= function filterFunction(element,typeToSearch) {
  var input, filter, obj,div,txtValue, i;
  input = element;
  filter = input.value.toUpperCase();
  div = element.parentElement.parentElement;
  obj = div.getElementsByTagName(typeToSearch);
  for (i = 0; i < obj.length; i++) {
    txtValue = obj[i].textContent || obj[i].innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      obj[i].style.display = "";
    } else {
      obj[i].style.display = "none";
    }
  }
}
